export const TYPES = ['tag', 'chip'];
export const THEMES = ['light', 'dark'];

export default {};
